export const isTrue = (value: string): boolean => {
    const lowered = value?.toLowerCase().trim();
    return lowered === 'true' || lowered === 'vrai' || lowered === 'oui' || lowered === '1';
};

export const isFalse = (value: string): boolean => {
    const lowered = value?.toLowerCase().trim();
    return lowered === 'false' || lowered === 'faux' || lowered === 'non' || lowered === '0';
};

export const isBoolean = (value: string): boolean => {
    return isTrue(value) || isFalse(value);
};

export const formatToNumber = (value: string): number => {
    return Number(value?.replace(',', '.'));
};

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const isIdField = (field: string): boolean => {
    const lowerField = field.toLowerCase().trim();
    return lowerField === '_id' || lowerField === 'id';
};

// Dates are stored and imported as BirthdayDate (YYYY-MM-DD).
export const isValidDate = (dateStr: string): boolean => {
    if (!DATE_REGEX.test(dateStr)) return false;

    const [year, month, day] = dateStr.split('-').map(Number);

    // Check that the values are in valid ranges
    if (year < 1900 || year > 2200) return false;
    if (month < 1 || month > 12) return false;

    // Get the last day of the month
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > lastDayOfMonth) return false;

    return true;
};
